import AdminLayout from "../layout/AdminLayout";
import AdminDashboard from "../views/Dashboard";
import NotificationsPage from "../views/Notifications";
import ModerationPage from "../views/Moderation";
import SubscriptionsPage from "../views/Subscriptions";
import AnalyticsPage from "../views/Analytics";
import MoodSymptomManager from "../views/MoodSymptomManager";
import JournalManager from "../views/JournalManager";
import CommunityUsersManager from "../views/CommunityUsersManager";
import ViewUser from "../views/ViewUser";
import UserProfile from "../views/Account/MyProfile";
import LegalManager from "../views/LegalManager";
import NewsletterSubscribers from "../views/NewsletterSubscribers";

const PrivateRoutes = [
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      { index: true, element: <AdminDashboard /> },
      { path: "dashboard", element: <AdminDashboard /> },
      { path: "users", element: <CommunityUsersManager /> },
      { path: "view-user", element: <ViewUser /> },
      { path: "moods", element: <MoodSymptomManager /> },
      { path: "journal", element: <JournalManager /> },
      { path: "notifications", element: <NotificationsPage /> },
      { path: "moderation", element: <ModerationPage /> },
      { path: "subscriptions", element: <SubscriptionsPage /> },
      { path: "analytics", element: <AnalyticsPage /> },
      { path: "legal", element: <LegalManager /> },
      { path: "newsletter-subscribers", element: <NewsletterSubscribers /> },
      { path: "my-profile", element: <UserProfile /> },
    ]
  }
];

export default PrivateRoutes;
